<template>
  <div :class="['countdown-page', size && `countdown-page-${size}`]">
    <div class="list">
      <div class="block">
        <div class="text">{{ handleFormat(day) }}</div>
      </div>
      <div class="dot">:</div>
      <div class="block">
        <div class="text">{{ handleFormat(hour) }}</div>
      </div>
      <div class="dot">:</div>
      <div class="block">
        <div class="text">{{ handleFormat(minute) }}</div>
      </div>
      <div class="dot">:</div>
      <div class="block">
        <div class="text">{{ handleFormat(second) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
const ONE_SECOND = 1000 * 1;
const ONE_MINUTE = ONE_SECOND * 60;
const ONE_HOUR = ONE_MINUTE * 60;
const ONE_DAY = ONE_HOUR * 24;

export default {
  props: {
    end_at: {
      type: Number,
      default: 0,
    },
    size: {
      type: String,
      default: "",
    },
  },
  watch: {
    end_at: {
      handler(value) {
        if (!value) {
          this.handleReset();
          return;
        }

        this.endAt = value;
        this.handleInitCountDown();
      },
      immediate: true,
      deep: true,
    },
    size: {
      handler(value) {
        this.pageSize = value;
      },
      immediate: true,
      deep: true,
    },
    day: {
      handler(value) {
        this.handleDayChangeEmit();
      },
      immediate: true,
      deep: true,
    },
  },
  setup(props, { emit }) {
    const day = ref(0);
    const hour = ref(0);
    const minute = ref(0);
    const second = ref(0);

    const timer = ref(null);

    const endAt = ref(0);
    const pageSize = ref("");

    /**
     * 处理倒计时
     */
    const handleInitCountDown = () => {
      const nowadays = new Date().getTime();
      const _diff = endAt.value - nowadays;

      // 天
      const days = Math.floor(_diff / ONE_DAY);
      // 小时
      const _time_left = _diff % ONE_DAY;
      const hours = Math.floor(_time_left / ONE_HOUR);
      // 分钟
      const _hour_left = _time_left % ONE_HOUR;
      const minutes = Math.floor(_hour_left / ONE_MINUTE);
      // 秒
      const _min_left = _hour_left % ONE_MINUTE;
      const seconds = Math.floor(_min_left / ONE_SECOND);

      day.value = days;
      hour.value = hours;
      minute.value = minutes;
      second.value = seconds;

      if (_diff <= 0) {
        emit("onCountDownEnd");
        handleReset();
      } else {
        timer.value && clearTimeout(timer.value);
        timer.value = setTimeout(() => {
          handleInitCountDown();
        }, 1000 * 1);
      }
    };

    /**
     * 处理重置
     */
    const handleReset = () => {
      day.value = 0;
      hour.value = 0;
      minute.value = 0;
      second.value = 0;
      timer.value && clearTimeout(timer.value);
    };

    /**
     * 处理格式化
     * @param value
     */
    const handleFormat = (value) => {
      return value >= 10 ? value : `0${value}`;
    };

    const handleDayChangeEmit = () => {
      emit("onDayChange");
    };

    return {
      day,
      hour,
      minute,
      second,
      timer,
      endAt,
      pageSize,
      handleFormat,
      handleReset,
      handleInitCountDown,
      handleDayChangeEmit,
    };
  },
};
</script>

<style lang="less" scoped>
.countdown-page {
  font-family: "Inter";

  .list {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    .block {
      width: 30px;
      height: 30px;
      border-radius: 1px;
      background: #2f87ad;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .text {
        color: #ffffff;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 18px;
      }
    }

    .dot {
      width: 12px;
      color: #4392c4;
      font-size: 12px;
      font-weight: 700;
      line-height: 18px;
      margin: 0px;
      text-align: center;
    }
  }
}

.countdown-page-detail {
  .list {
    .block {
      width: 46px;
      height: 46px;
      border-radius: 1.35px;
      border: 0.68px solid #64b3d4;
      background: #2f87ad33;

      .text {
        color: #ffffff;
        text-align: center;
        font-family: "Inter";
        font-size: 13.66px;
        font-style: normal;
        font-weight: 400;
        line-height: 24.35px;
      }
    }

    .dot {
      width: 17px;
      color: #4392c4;
      font-family: "Inter";
      font-size: 16.24px;
      font-style: normal;
      font-weight: 700;
      line-height: 24.35px;
      margin: 0px 6.76px;
    }
  }
}
</style>
